export default "__VITE_ASSET__BQgbcXCj__"